import { withInstall } from '@ideaz/utils'
import Text from './src/index'

export * from './src/text'
export default withInstall(Text)
